import React from "react";
import { Outlet } from "react-router-dom";
import MobileNavbar from "../../components/MobileNavbar/MobileNavbar";
import Popup from "../../components/Popup/Popup";
import { useLanguage } from "../../Context/LanguageContext";
import "../../pages/MainPage/MainPage.css";

function MainPage() {
  const { isNavbarOpen, setIsNavbarOpen } = useLanguage();

  return (
    <div className="main-page">
      <Popup
        className="navbar-popup"
        setIsNavbarOpen={setIsNavbarOpen}
        isNavbarOpen={isNavbarOpen}
      >
        <MobileNavbar />
      </Popup>
      <Outlet />
    </div>
  );
}

export default MainPage;
